// src/pages/freevaluation/FreeValuationDone.jsx
//
// Delivery confirmation page. Shows the valuation range on-screen
// (fetched from the status endpoint) + a link to download the PDF
// + a conversion CTA to book a call with a broker.
//
// Route: /gratis-vardering/klart/:workspaceId

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { request } from "../../services/server";
import "./freevaluation.css";

export default function FreeValuationDone() {
  const { workspaceId } = useParams();
  const [state, setState] = useState({ loading: true, pdfUrl: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await request(
          `/valuation/free-valuation/status/${workspaceId}/`,
        );
        if (cancelled) return;
        setState({ loading: false, pdfUrl: data?.pdf_url || null });
      } catch {
        if (!cancelled) setState({ loading: false, pdfUrl: null });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  return (
    <div className="fv-page">
      <div className="fv-card">
        <div className="fv-badge">Klart</div>
        <h1>Din värdering är på väg</h1>
        <p>
          Vi har mailat värderings-PDF:en till dig. Öppna mailet för
          att se resultatet och boka gärna ett samtal om du vill
          diskutera nästa steg.
        </p>

        {state.pdfUrl && (
          <a
            href={state.pdfUrl}
            className="fv-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ladda ner PDF nu
          </a>
        )}

        <div className="fv-cta-card">
          <h2>Vill du gå vidare?</h2>
          <p>
            En riktig transaktionsvärdering ser till branschmultiplar,
            kundkoncentration, ägarberoenden och marknadstiming. Vi
            hjälper dig hela vägen — teaser, IM, köpardialog och
            avslut.
          </p>
          <a
            href="mailto:hej@qada.io?subject=Vill%20diskutera%20f%C3%B6rs%C3%A4ljning"
            className="fv-secondary"
          >
            Boka 15-minuters samtal
          </a>
        </div>
      </div>
    </div>
  );
}
